function cartReturnUrl() {
  var params = new URLSearchParams(window.location.search);
  var preview = params.get('preview_theme_id');
  return preview ? '/cart?preview_theme_id=' + encodeURIComponent(preview) : '/cart';
}

function resetOfferButton(button) {
  if (!button) return;
  button.disabled = false;
  button.innerHTML = button.dataset.originalLabel || 'Choose this offer';
}

function selectedPlan(page) {
  return page.querySelector('[data-plan].selected') || page.querySelector('[data-plan][aria-checked="true"]');
}

function activeBuildFlavours(page) {
  return Array.prototype.slice.call(page.querySelectorAll('.flavour-grid button.active:not([disabled])'));
}

function activeSingleFlavour(page) {
  return page.querySelector('[data-single-flavour].active:not([disabled])');
}

function buildFlavourAllocations(flavours, packCount) {
  var count = flavours.length;
  if (!count || packCount < 1) return [];
  var base = Math.floor(packCount / count);
  var remainder = packCount % count;
  return flavours.map(function (item, index) {
    return {
      name: item.dataset.flavour || 'Flavour',
      qty: base + (index < remainder ? 1 : 0),
      variantId: item.dataset.variantId || '',
      available: item.dataset.available !== 'false'
    };
  });
}

function formatFlavourAllocation(allocations) {
  return allocations.map(function (item) {
    return item.name + ' ×' + item.qty;
  }).join(', ');
}

function syncBuildFlavourProperty(page, packCount) {
  var flavourProperty = page.querySelector('[data-flavour-property]');
  var includesProperty = page.querySelector('[data-includes-property]');
  var allocations = buildFlavourAllocations(activeBuildFlavours(page), packCount || 1);
  var label = formatFlavourAllocation(allocations);
  if (flavourProperty) flavourProperty.value = label;
  if (includesProperty) includesProperty.value = label;
  return allocations;
}

function syncOfferVariantFromSelection(page) {
  var plan = selectedPlan(page);
  var variantInput = page.querySelector('input[name="id"]');
  var submitButton = page.querySelector('.offer-product-form .pdp-cta');
  var includesProperty = page.querySelector('[data-includes-property]');
  if (!plan || !variantInput) return;

  var usesFlavourVariant = plan.dataset.usesFlavourVariant === 'true' || plan.dataset.singlePack === 'true';
  var choiceCount = Number(plan.dataset.choiceCount || 1);

  if (page.dataset.offerId === 'build-your-box') {
    var buildFlavours = activeBuildFlavours(page);
    var allocations = syncBuildFlavourProperty(page, choiceCount);

    if (usesFlavourVariant || choiceCount === 1) {
      var one = buildFlavours[0];
      if (one) {
        variantInput.value = one.dataset.variantId || '';
        if (includesProperty) includesProperty.value = (one.dataset.flavour || '') + ' ×1';
        page.querySelectorAll('[data-offer-price], [data-sticky-price]').forEach(function (item) {
          item.textContent = one.dataset.price || plan.dataset.price;
        });
        var planPrice = plan.querySelector('.plan-money b');
        if (planPrice && one.dataset.price) planPrice.textContent = one.dataset.price;
        plan.dataset.variantId = one.dataset.variantId || '';
        plan.dataset.price = one.dataset.price || plan.dataset.price;
      } else {
        variantInput.value = '';
      }
    } else {
      variantInput.value = plan.dataset.variantId || '';
      page.querySelectorAll('[data-offer-price], [data-sticky-price]').forEach(function (item) {
        item.textContent = plan.dataset.price;
      });
    }

    if (submitButton) {
      var hasFlavours = buildFlavours.length >= 1 && buildFlavours.length <= choiceCount;
      var allAvailable = allocations.every(function (item) { return item.available && item.qty > 0; });
      submitButton.disabled = !(variantInput.value && hasFlavours && allAvailable) || plan.disabled;
    }

    var mixHint = page.querySelector('[data-mix-hint]');
    if (mixHint) {
      if (!allocations.length) {
        mixHint.textContent = 'Select 1–' + choiceCount + ' flavours. We’ll split the packs across your mix.';
      } else {
        mixHint.textContent = 'Your mix: ' + formatFlavourAllocation(allocations);
      }
    }
    return;
  }

  if (page.dataset.offerId === 'pomegranate' && usesFlavourVariant) {
    var single = activeSingleFlavour(page);
    if (single) {
      variantInput.value = single.dataset.variantId || '';
      plan.dataset.variantId = single.dataset.variantId || '';
      plan.dataset.price = single.dataset.price || plan.dataset.price;
      if (includesProperty) includesProperty.value = (single.dataset.flavour || 'Pomegranate') + ' × 1';
      page.querySelectorAll('[data-offer-price], [data-sticky-price]').forEach(function (item) {
        item.textContent = single.dataset.price || plan.dataset.price;
      });
      if (submitButton) submitButton.disabled = !single.dataset.variantId || single.dataset.available === 'false' || plan.disabled;
    }
    return;
  }

  variantInput.value = plan.dataset.variantId || '';
  if (submitButton) submitButton.disabled = !plan.dataset.variantId || plan.disabled;
}

function updatePomIncludeRow(page, flavourButton, qtyLabel) {
  var title = page.querySelector('[data-pom-include-title]');
  var meta = page.querySelector('[data-pom-include-meta]');
  var qty = page.querySelector('[data-pom-include-qty]');
  var row = page.querySelector('[data-pom-include-row]');
  var image = page.querySelector('[data-pom-include-image]');
  if (!flavourButton) return;
  if (title) title.textContent = flavourButton.dataset.flavour || 'Pomegranate';
  if (meta) {
    if (flavourButton.dataset.available === 'false') meta.textContent = 'Currently unavailable';
    else meta.textContent = (flavourButton.dataset.stock || '0') + ' in stock · ' + (flavourButton.dataset.price || '');
  }
  if (qty) qty.textContent = qtyLabel || '× 1';
  if (row) row.classList.toggle('is-unavailable', flavourButton.dataset.available === 'false');
  if (image && flavourButton.dataset.image) image.src = flavourButton.dataset.image;
}

document.addEventListener('click', function (event) {
  var plan = event.target.closest('[data-plan]');
  if (plan) {
    var page = plan.closest('.offer-page');
    page.querySelectorAll('[data-plan]').forEach(function (item) {
      item.classList.toggle('selected', item === plan);
      item.setAttribute('aria-checked', item === plan ? 'true' : 'false');
    });

    var quantity = page.querySelector('[data-offer-quantity]');
    if (quantity) quantity.value = plan.dataset.quantity || '1';

    var flavourGrid = page.querySelector('.flavour-grid');
    if (flavourGrid && plan.dataset.choiceCount) {
      flavourGrid.dataset.flavourLimit = plan.dataset.choiceCount;
      var allowed = Number(plan.dataset.choiceCount);
      var active = Array.prototype.slice.call(flavourGrid.querySelectorAll('button.active'));
      active.forEach(function (item, index) {
        if (index >= allowed) {
          item.classList.remove('active');
          var mark = item.querySelector('span:last-child');
          if (mark) mark.textContent = '+';
        }
      });
      // If switching to single-pack and nothing selected, keep first available active.
      if (allowed === 1 && flavourGrid.querySelectorAll('button.active').length === 0) {
        var firstAvailable = flavourGrid.querySelector('button:not([disabled])');
        if (firstAvailable) {
          firstAvailable.classList.add('active');
          var firstMark = firstAvailable.querySelector('span:last-child');
          if (firstMark) firstMark.textContent = '✓';
        }
      }
    }

    var singleFlavourSelector = page.querySelector('[data-single-flavour-selector]');
    if (singleFlavourSelector) singleFlavourSelector.hidden = plan.dataset.singlePack !== 'true';

    var sellingPlan = page.querySelector('[data-offer-selling-plan]');
    if (sellingPlan) {
      sellingPlan.value = plan.dataset.sellingPlan || '';
      sellingPlan.disabled = !plan.dataset.sellingPlan;
    }

    page.querySelectorAll('[data-offer-price], [data-sticky-price]').forEach(function (item) {
      item.textContent = plan.dataset.price;
    });
    var label = plan.querySelector('.plan-copy b');
    var stickyLabel = page.querySelector('[data-sticky-label]');
    if (label && stickyLabel) stickyLabel.textContent = label.textContent;
    var stickyDetail = page.querySelector('[data-sticky-detail]');
    if (stickyDetail) stickyDetail.textContent = plan.dataset.detail || '';

    // Pomegranate multi-pack include qty
    if (page.dataset.offerId === 'pomegranate' && plan.dataset.singlePack !== 'true') {
      var qtyLabel = Number(plan.dataset.choiceCount || 1) >= 6 ? '× 6' : '× 3';
      var pomDefault = page.querySelector('[data-single-flavour]');
      updatePomIncludeRow(page, pomDefault, qtyLabel);
      var includesProperty = page.querySelector('[data-includes-property]');
      if (includesProperty && pomDefault) {
        includesProperty.value = (pomDefault.dataset.flavour || 'Pomegranate') + ' ' + qtyLabel.replace('× ', '×');
      }
    }

    if (page.dataset.offerId === 'pomegranate' && plan.dataset.singlePack === 'true') {
      var activeSingle = activeSingleFlavour(page) || page.querySelector('[data-single-flavour]');
      updatePomIncludeRow(page, activeSingle, '× 1');
    }

    syncOfferVariantFromSelection(page);
  }

  var flavour = event.target.closest('.flavour-grid button');
  if (flavour && !flavour.disabled) {
    var grid = flavour.closest('.flavour-grid');
    var pageFromFlavour = flavour.closest('.offer-page');
    var limit = Number(grid.dataset.flavourLimit || 3);
    if (limit === 1) {
      grid.querySelectorAll('button').forEach(function (item) {
        item.classList.remove('active');
        var mark = item.querySelector('span:last-child');
        if (mark) mark.textContent = '+';
      });
    }
    if (!flavour.classList.contains('active') && grid.querySelectorAll('button.active').length >= limit) {
      var first = grid.querySelector('button.active');
      if (first) {
        first.classList.remove('active');
        var firstMark = first.querySelector('span:last-child');
        if (firstMark) firstMark.textContent = '+';
      }
    }
    flavour.classList.toggle('active');
    var flavourMark = flavour.querySelector('span:last-child');
    if (flavourMark) flavourMark.textContent = flavour.classList.contains('active') ? '✓' : '+';
    syncOfferVariantFromSelection(pageFromFlavour);
  }

  var singleFlavour = event.target.closest('[data-single-flavour]');
  if (singleFlavour && !singleFlavour.disabled) {
    var singlePage = singleFlavour.closest('.offer-page');
    singlePage.querySelectorAll('[data-single-flavour]').forEach(function (item) {
      item.classList.toggle('active', item === singleFlavour);
      var icon = item.querySelector('i');
      if (icon) icon.textContent = item === singleFlavour ? '✓' : '+';
    });

    var selectionLabel = singlePage.querySelector('[data-single-selection-label]');
    if (selectionLabel) selectionLabel.textContent = singleFlavour.dataset.flavour;

    var flavourPropertyInput = singlePage.querySelector('[data-single-flavour-property]');
    if (flavourPropertyInput) flavourPropertyInput.value = singleFlavour.dataset.flavour;

    var featuredImage = singlePage.querySelector('[data-single-featured-image]');
    if (featuredImage && singleFlavour.dataset.image) {
      featuredImage.src = singleFlavour.dataset.image;
      featuredImage.alt = 'Glowming ' + singleFlavour.dataset.flavour;
    }

    var singlePlan = singlePage.querySelector('[data-single-pack="true"]');
    if (singlePlan) {
      singlePlan.dataset.variantId = singleFlavour.dataset.variantId || '';
      singlePlan.dataset.price = singleFlavour.dataset.price || singlePlan.dataset.price;
      var singlePlanPrice = singlePlan.querySelector('.plan-money b');
      if (singlePlanPrice) singlePlanPrice.textContent = singlePlan.dataset.price;
    }

    updatePomIncludeRow(singlePage, singleFlavour, '× 1');
    syncOfferVariantFromSelection(singlePage);
  }
});

document.addEventListener('submit', function (event) {
  var form = event.target.closest('.offer-product-form');
  if (!form || form.dataset.nativeSubmit === 'true') return;
  event.preventDefault();

  var page = form.closest('.offer-page');
  if (page) syncOfferVariantFromSelection(page);

  var submitButton = form.querySelector('.pdp-cta');
  if (submitButton) {
    submitButton.disabled = true;
    submitButton.dataset.originalLabel = submitButton.innerHTML;
    submitButton.textContent = 'Adding…';
  }

  var variantInput = form.querySelector('input[name="id"]');
  var quantityInput = form.querySelector('input[name="quantity"]');
  var sellingPlanInput = form.querySelector('input[name="selling_plan"]');
  var variantId = variantInput && variantInput.value ? Number(variantInput.value) : NaN;
  var isBuildYourBox = page && page.dataset.offerId === 'build-your-box';
  var isGlowOnRepeat = page && (page.dataset.offerId === 'glow-on-repeat' || page.dataset.offerId === 'subscribe-save');
  var payload;
  var plan = selectedPlan(page);

  if (!isBuildYourBox && !variantId) {
    resetOfferButton(submitButton);
    window.alert('Select an available flavour/offer before adding to cart.');
    return;
  }

  // Glow on Repeat: add Shopify bundle 10462533288253 only.
  // No Seal selling_plan — this is a one-time bundle purchase.
  if (isGlowOnRepeat) {
    if (!variantId) {
      resetOfferButton(submitButton);
      window.alert('Bundle product is unavailable right now.');
      return;
    }

    payload = {
      items: [{
        id: variantId,
        quantity: Number((quantityInput && quantityInput.value) || 1),
        properties: {
          _Offer: (page && page.dataset.offerId) || 'glow-on-repeat',
          Includes: 'Cafe Latte ×1, Pomegranate ×1, Pure Collagen ×1',
          'Purchase type': 'One-time purchase'
        }
      }]
    };
  } else if (isBuildYourBox) {
    var packCount = Number((plan && plan.dataset.choiceCount) || 1);
    var selectedCount = activeBuildFlavours(page).length;
    if (selectedCount < 1) {
      resetOfferButton(submitButton);
      window.alert('Select at least 1 flavour for your box.');
      return;
    }
    if (selectedCount > packCount) {
      resetOfferButton(submitButton);
      window.alert('Select up to ' + packCount + ' flavour' + (packCount === 1 ? '' : 's') + ' for this offer.');
      return;
    }

    var allocations = syncBuildFlavourProperty(page, packCount);
    var mixLabel = formatFlavourAllocation(allocations);
    var boxItems = allocations
      .filter(function (item) { return item.variantId && item.qty > 0; })
      .map(function (item) {
        return {
          id: Number(item.variantId),
          quantity: item.qty,
          properties: {
            _Offer: 'build-your-box',
            'Box size': packCount + ' packs',
            Includes: mixLabel
          }
        };
      });

    if (!boxItems.length) {
      resetOfferButton(submitButton);
      window.alert('Select an available flavour before adding to cart.');
      return;
    }

    payload = { items: boxItems };
  } else {
    var properties = {};
    Array.prototype.forEach.call(form.querySelectorAll('input[name^="properties["]'), function (input) {
      if (input.disabled) return;
      var key = input.name.slice(11, -1);
      properties[key] = input.value;
    });

    payload = {
      items: [{
        id: variantId,
        quantity: Number((quantityInput && quantityInput.value) || 1),
        properties: properties
      }]
    };

    if (sellingPlanInput && !sellingPlanInput.disabled && sellingPlanInput.value) {
      payload.items[0].selling_plan = Number(sellingPlanInput.value);
    }
  }

  var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
  var timedOut = false;
  var timeoutId = window.setTimeout(function () {
    timedOut = true;
    if (controller) controller.abort();
  }, 8000);

  var returnInput = form.querySelector('input[name="return_to"]');
  if (!returnInput) {
    returnInput = document.createElement('input');
    returnInput.type = 'hidden';
    returnInput.name = 'return_to';
    form.appendChild(returnInput);
  }
  returnInput.value = cartReturnUrl();

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify(payload),
    credentials: 'same-origin',
    signal: controller ? controller.signal : undefined
  })
    .then(function (response) {
      return response.text().then(function (text) {
        var data = null;
        try { data = text ? JSON.parse(text) : null; } catch (e) { data = null; }
        if (!response.ok) {
          var message = (data && (data.description || data.message)) || ('Could not add offer to cart (' + response.status + ')');
          throw new Error(message);
        }
        return data;
      });
    })
    .then(function () {
      window.clearTimeout(timeoutId);
      window.location.assign(cartReturnUrl());
    })
    .catch(function (error) {
      window.clearTimeout(timeoutId);

      // Don't native-submit Build Your Box (that would add a fixed draft bundle mix).
      if (!isBuildYourBox && (timedOut || (error && error.name === 'AbortError'))) {
        form.dataset.nativeSubmit = 'true';
        form.submit();
        return;
      }
      resetOfferButton(submitButton);
      window.alert((error && error.message) || 'Could not add offer to cart');
    });
});
